import { Box, Tab, Tabs } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Item } from '../../../common/snippets'
import { bookingPageTabIds } from '../GSConstants'
import DefineCargoServiceType from './defineCargoService'
import KGKMRateMatrix from './kgkmRateMatrx'
import RateCrossingBulkUpdate from './rateCrossingBulk'
import StandardRateMatrix from './standardRateMatrix'
import ViewBranchWiseKgkm from './viewBranchWiseKgkm'
import CityPairRateMatrix from './CityPairRateMatrix'
import { connect } from 'react-redux'
import { getServiceTypeListAllData } from '../../../../store/generalSetting/GSAction'
import { findObjctByValueFromArrayOfObject, isEmpty } from '../../../common/helper'
import ViewRateMatrix from './ViewRateMatrix'
import { useTranslation } from '../../../../i18n/I18nProvider'

export const standardRateTabs = [
  // { JobID: 542, name: 'Define Cargo Service Type' },
  { JobID: 478, name: 'KG-KM Rate Matrix', translationKey: 'kgKmRateMatrix' },
  { JobID: 471, name: 'Standard Rate Matrix', translationKey: 'standardRateMatrix' },
  { JobID: 543, name: 'City Pair Rate Matrix', translationKey: 'cityPairRateMatrix' },
  // { JobID: 3, name: 'Rate-Crossing Bulk Update' },
  { JobID: 544, name: 'View Rate Matrix', translationKey: 'viewRateMatrix' },
]
const StandardRate = (props) => {
  const { data, getServiceTypeListAllData } = props
  const { common } = data
  const { loginData } = common
  const { translations } = useTranslation()
  const generalSettings = translations?.generalSettings || {}
  const [searchParams, setSearchParams] = useSearchParams()
  const [contentView, setContentView] = useState('')
  const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id')) || 478)
  const [allTabs, setAllTabs] = useState([])

  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  useEffect(() => {
    const allGSPages = sessionStorage.getItem('token1');
    const allGSPagesActive = JSON.parse(allGSPages);
    // if (selectedTab === '' || selectedTab === undefined) {
    //   const newData = standardRateTabs.filter((item) => findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null)
    //   goToTabs(newData?.[0]?.JobID, {})
    // }

    if (allGSPagesActive?.length > 0) {
      setAllTabs(allGSPagesActive)
    } else {
      setAllTabs([])
    }
  }, [searchParams, selectedTab]);
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let multiCargoBody = {
        CargoServiceType: -1,
        CompanyID: loginData?.intCompanyID,
        IsActive: 1
      }
      getServiceTypeListAllData(multiCargoBody)
    }
  }, [selectedTab, loginData])

  const contentShow = (key) => {
    let GeneralSettingType
    switch (key) {
      case 542: {
        GeneralSettingType = <DefineCargoServiceType />
        break
      }
      case 478: {
        GeneralSettingType = <KGKMRateMatrix />
        break
      }
      case 471: {
        GeneralSettingType = <StandardRateMatrix />
        break
      }
      // case 3: {
      //   GeneralSettingType = <RateCrossingBulkUpdate />
      //   break
      // }
      // case 544: {
      //   GeneralSettingType = <ViewBranchWiseKgkm />
      //   break
      // }
      case 543: {
        GeneralSettingType = <CityPairRateMatrix />
        break;
      }
      case 544: {
        GeneralSettingType = <ViewRateMatrix />
        break
      }
      default:
        GeneralSettingType = ''
        break
    }
    return GeneralSettingType
  }

  const goToTabs = (lrTab) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
  }
  return (
    <>
      <Box className="">
        <Item sx={{ paddingTop: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              variant="scrollable"
              value={selectedTab}
              onChange={(e, newValue) => goToTabs(newValue)}
              aria-label="bsic tabs example"
              sx={{
                minHeight: 'unset',
                alignItems: 'center',
                fontSize: '1 rem',
              }}
            >
              {standardRateTabs.map((reqType, index) => (
                <Tab
                  key={`sender_${reqType.JobID}`}
                  value={reqType.JobID}
                  label={generalSettings?.[reqType.translationKey] || reqType.name}
                  {...bookingPageTabIds(reqType.JobID)}
                  sx={{
                    fontSize: '1rem', height: '40px', minHeight: '40px', fontSize: '12px', fontWeight: '600',
                    display: findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID', "IsActive") === 1
                      ? 'block'
                      : 'none',
                  }}
                />
              ))}
            </Tabs>
          </Box>
          {standardRateTabs.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
              sx={{
                display: findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID', "IsActive") === 1
                  ? 'block'
                  : 'none',
              }}
            >
              {contentShow(reqType.JobID)}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getServiceTypeListAllData }
export default connect(mapStateToProps, mapDispatchToProps)(StandardRate)
